import { pipe, Result } from '@blade/std-lib'
import { fetchHoldersRequestAction } from '@root/features/trade/holders'
import { reatomDataTable } from '@root/shared/ui-kit'

import { createTrackedWalletTableColumns } from './reatom-tracked-wallet-columns'

import type { Network } from '@root/entities/network'
import type { PairAddress } from '@root/entities/pair'
import type { Maker } from '@root/entities/trade'
import type { WalletAddress } from '@root/entities/wallet'
import type { TableData } from '@root/shared/ui-kit'

export const reatomTrackedWalletTable = (options: {
  pairAddress: PairAddress
  makerAddress: WalletAddress
  network: Network.Network
}) => {
  const tableModel = reatomDataTable({
    columns: createTrackedWalletTableColumns(),
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'pair-holders-table',
    loadItems: async (ctx, { filters }) => {
      const result = await fetchHoldersRequestAction(ctx, {
        network: options.network,
        // TODO: Val - add filter by makerAddress to ServicesMakerHoldersListParams
        // makerAddress: options.makerAddress,
        pairAddress: options.pairAddress,
      })

      return pipe(
        result,
        Result.map(
          (data): TableData<Maker.Maker> => ({
            data: data.filter((holder) => {
              const { maker } = filters
              if (maker && maker.type === 'string' && maker.operator === 'eq') {
                return holder.address === maker.value
              }
              return true
            }),
            hasNext: false,
          }),
        ),
      )
    },
    getId: (item) => item.address,
  })

  return tableModel
}
